enum Path {
  HOME = '/',
  CONTACT = '/contact',
  CUSTOMERS = '/customers',
  PROJECTS = '/projects',
  MEMBERS = '/members',
  MEMBERS_EDIT = '/members/edit/:id',
  PROFILE = '/profile',
  TIMESHEET = '/timesheet',
  TIMESHEET_REPORT = '/report',
  TIMESHEET_REPORT_REVIEW = '/report/review',
  TIMESHEET_APPROVAL_REVIEW = '/approval/review',
  CV_SHARE = '/cv',
  TIMESHEET_OVERVIEW = '/overview',
  TIMESHEET_APPROVAL = '/approval',
  TEAM = '/teams',
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/password-reset',
  INVITE_MEMBER = '/join',
  ASSIGNMENT = '/assignment',
  ASSIGNMENT_SUMMARY = '/assignment_summary',
  COMMIT_EFFORT = '/commit_effort',
  ASSIGNABLE = '/assignable',
  CUSTOMER_TIMESHEET_REPORT = '/timesheet_report',
  TEAM_PROPOSAL = '/proposals',
}

export default Path;
